module.exports = __webpack_public_path__ + "img/creators-club-channels.7a94027f.png";